exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-padding[data-v-9b3f5c8e]{\n  padding: 7px;\n}\n.file-upload[data-v-9b3f5c8e]{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.upload-document table tr td a[data-v-9b3f5c8e]:last-child {\n    margin-left: 15px;\n    color: #f12121;\n}\n.upload-document table tr td a[data-v-9b3f5c8e] {\n    font-size: 20px;\n    color: #0056e0;\n}\n", ""]);

// exports
